<template>
  <div id="app">
    <Header @hidden="hidePage" />
    <router-view v-show=showPage />
    <Footer v-show=showPage />
  </div>
</template>

<script>
import Header from './components/Header.vue'
import Footer from './components/Footer.vue'

export default {
  name: 'app',

  components: {
    Header,
    Footer
  },
  data () {
    return {
      showPage: true
    }
  },
  methods: {
    hidePage (param) {
      console.log(param)
      this.showPage = !param
    }
  },
  beforeCreate: function () {
    document.body.className = 'dark-hamburger'
    document.documentElement.className = 'flexbox canvas canvastext webgl no-touch geolocation postmessage websqldatabase indexeddb hashchange history draganddrop websockets rgba hsla multiplebgs backgroundsize borderimage borderradius boxshadow textshadow opacity cssanimations csscolumns cssgradients cssreflections csstransforms csstransforms3d csstransitions fontface generatedcontent video audio localstorage sessionstorage webworkers applicationcache svg inlinesvg smil svgclippaths'
  }
}
</script>

<style>
#app {
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/App.vue